import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Plus, FileText } from 'lucide-react';
import { StatusBadge } from '../StatusBadge';

export function ClientDocumentsSection({ clientId, documents, onMarkSigned }) {
  const navigate = useNavigate();

  return (
    <div>
      <div className="flex items-center justify-between mb-3">
        <h2 className="text-xl font-serif font-bold text-foreground flex items-center gap-2">
          <FileText className="w-5 h-5" />
          Documents
        </h2>
        <button
          onClick={() => navigate(`/documents/new?client=${clientId}`)}
          className="text-primary hover:text-primary/80 text-sm flex items-center gap-1"
          data-testid="add-document-button"
        >
          <Plus className="w-4 h-4" />
          New
        </button>
      </div>
      {documents.length === 0 ? (
        <div className="bg-surface border border-border rounded-lg p-4 text-center text-text-muted text-sm">
          No documents yet
        </div>
      ) : (
        <div className="space-y-2">
          {documents.map((doc) => (
            <div
              key={doc.id}
              className="bg-surface border border-border rounded-lg p-3"
              data-testid={`document-${doc.id}`}
            >
              <div className="flex items-start justify-between mb-1">
                <h3 className="font-medium text-foreground">{doc.title}</h3>
                <div className="flex items-center gap-2">
                  {doc.status === 'sent' && (
                    <button
                      onClick={() => onMarkSigned(doc.id)}
                      className="text-xs bg-success/10 text-success px-2 py-1 rounded border border-success/20 hover:bg-success/20 transition-colors"
                      data-testid={`mark-signed-${doc.id}`}
                    >
                      Mark Signed
                    </button>
                  )}
                  <StatusBadge status={doc.status} />
                </div>
              </div>
              <p className="text-sm text-text-secondary">{doc.doc_type}</p>
              {doc.expiry_date && (
                <p className="text-xs text-text-muted mt-1">Expires: {doc.expiry_date}</p>
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
